import EntitySubtitle from "./EntitySubtitle";

export default EntitySubtitle;
